import { createAsyncThunk } from "@reduxjs/toolkit";

import { handleFetch } from "src/api";
import { BlogType } from "src/shared/config";
import { endPoints } from "src/shared/model";
import { RootState } from "src/app/model/store";

export const sendMessage = createAsyncThunk<void>(
  "contact/sendMessage",
  async (_, { getState }) => {
    const state = getState() as RootState;
    const email = state.contact.email;
    const message = state.contact.message;
    const fullName = state.contact.fullName;

    await handleFetch<
      {
        email: string;
        message: string;
        fullName: string;
      },
      { success: BlogType[] }
    >({
      url: endPoints.blogs,
      method: "POST",
      data: {
        email,
        message,
        fullName,
      },
    });
  },
);
